module.exports = __webpack_public_path__ + "img/ilabel.2b4dd5a2.png";